module.exports = __webpack_public_path__ + "static/media/le-burger-royale-mb.c442fc2c.jpg";